import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rule", "manual"]

  selectRule(event) {
    const selected = this.ruleTargets.find(rule => rule.dataset.ruleId === event.target.value)
    if (!selected) return

    this.ruleTargets.forEach(rule => { rule.hidden = rule !== selected })
    if (this.hasManualTarget) {
      this.manualTarget.open = false
      const account = this.manualTarget.querySelector('select[name="apply_category"]')
      const property = this.manualTarget.querySelector('select[name="cost_centre_id"]')
      account.value = selected.dataset.accountId ? `apply-${selected.dataset.accountId}` : "select"
      property.value = selected.dataset.costCentreId || "select"
      account.dispatchEvent(new Event("change", { bubbles: true }))
      property.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  chooseCategory() {
    this.manualTarget.open = true
    this.manualTarget.querySelector("select").focus()
  }
}
